import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/sonachandi.jpeg";
import "./Login.css";
import { loginApi } from "../../services/Login/login.service";
import { json } from "node:stream/consumers";

interface LoginProps {
  setIsAuthenticated: (value: boolean) => void;
}

const Login: React.FC<LoginProps> = ({ setIsAuthenticated }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setLoading(true);

      const res:any = await loginApi({
        email,
        password,
      });

      // console.log(res.data);
      

      // ✅ Token & auth state
      localStorage.setItem("token", res.token);
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("user",JSON.stringify(res?.data) );

      setIsAuthenticated(true);
      navigate("/dashboard");
    } catch (error: any) {
      alert(
        error.response?.data?.message || "Invalid email or password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        {/* Left Brand */}
        <div className="brand-section">
          <img src={logo} alt="Sona Chandi Wale" />
          <h1>SonaChandiWale</h1>
          <p>Premium Gold & Silver Management</p>
        </div>

        {/* Right Form */}
        <div className="form-section">
          <h2>Welcome Back</h2>
          <span>Sign in to continue</span>

          <form onSubmit={handleLogin}>
            <div className="field">
              <label>Email</label>
              <input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="field">
              <label>Password</label>
              <div className="password-box">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <i onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? "🙈" : "👁"}
                </i>
              </div>
            </div>

            <div className="forgot">Forgot password?</div>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>

          <footer>© 2026 Sona Chandi</footer>
        </div>
      </div>
    </div>
  );
};

export default Login;
